import React from "react";
import { buildShipmentUrl } from "../../../utils/shipmentNavigation";

const number = (value, digits = 2) => value == null ? "—" : Number(value).toLocaleString("nl-NL", { maximumFractionDigits: digits });

export const CustomsInvoiceSummary = ({ snapshot }) => (
  <div className="min-w-0 space-y-4" data-testid="customs-summary">
    <div className="grid grid-cols-2 gap-3 border-y py-3 sm:grid-cols-4">
      {[["shipments", "Zendingen"], ["pieces", "Colli"], ["weight_kg", "Werkelijk kg"], ["cbm", "CBM"]].map(([key, label]) => (
        <div key={key}>
          <div className="text-xs text-slate-500">{label}</div>
          <div className="text-lg font-semibold" data-testid={`customs-total-${key.replaceAll("_", "-")}`}>{number(snapshot.totals[key], 4)}</div>
        </div>
      ))}
    </div>
    <div className="flex flex-wrap gap-x-6 gap-y-2" data-testid="customs-value-totals">
      {Object.entries(snapshot.totals.values).map(([currency, value]) => (
        <strong key={currency} className="text-sm" data-testid={`customs-total-value-${currency.toLowerCase()}`}>{currency} {number(value)}</strong>
      ))}
    </div>
    {snapshot.validation_issues.length > 0 && (
      <div role="alert" className="max-h-40 overflow-y-auto border-l-4 border-amber-500 bg-amber-50 p-3 text-sm" data-testid="customs-validation-issues">
        {snapshot.validation_issues.map((issue, index) => <p key={index} className="break-words" data-testid={`customs-validation-issue-${index}`}>{issue.message}</p>)}
      </div>
    )}
    <div className="divide-y" data-testid="customs-shipment-list">
      {snapshot.shipments.map((shipment) => (
        <section key={shipment.shipment_id} className="min-w-0 py-3" data-testid={`customs-shipment-${shipment.shipment_id}`}>
          <div className="flex flex-wrap items-start justify-between gap-2">
            <div className="min-w-0 flex-1">
              <strong className="break-all text-sm" data-testid={`customs-wnumber-${shipment.shipment_id}`}>{shipment.w_number}</strong>
              <p className="break-words text-sm [overflow-wrap:anywhere]" data-testid={`customs-customer-${shipment.shipment_id}`}>{shipment.customer_name || "Klantnaam ontbreekt"}</p>
            </div>
            <a href={buildShipmentUrl({ shipmentId: shipment.shipment_id, wNumber: shipment.w_number })}
               target="_blank" rel="noreferrer" className="text-xs text-blue-700 underline"
               data-testid={`customs-open-source-${shipment.shipment_id}`}>Bron openen</a>
          </div>
          <p className="mt-1 text-xs text-slate-600" data-testid={`customs-metrics-${shipment.shipment_id}`}>
            {shipment.piece_count} colli · {number(shipment.weight_kg)} kg · {number(shipment.cbm, 4)} m³
          </p>
          <p className="mt-1 break-words text-sm [overflow-wrap:anywhere]" data-testid={`customs-contents-${shipment.shipment_id}`}>{shipment.contents_description || "Inhoud ontbreekt"}</p>
          <div className="mt-2 space-y-2">
            {shipment.pieces.map((piece, index) => (
              <div key={index} className="border-l-2 border-slate-200 pl-3 text-xs" data-testid={`customs-piece-${shipment.shipment_id}-${index}`}>
                <p className="break-words [overflow-wrap:anywhere]" data-testid={`customs-piece-contents-${shipment.shipment_id}-${index}`}>{piece.quantity}× {piece.description || "Inhoud ontbreekt"}</p>
                <p className="break-words" data-testid={`customs-piece-metrics-${shipment.shipment_id}-${index}`}>{piece.dimensions || "Maten ontbreken"} · {number(piece.weight_kg)} kg · {number(piece.cbm, 4)} m³</p>
                <p data-testid={`customs-piece-value-${shipment.shipment_id}-${index}`}>{piece.value == null ? "Waarde ontbreekt" : `${piece.currency || "Valuta ontbreekt"} ${number(piece.value)}`}</p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  </div>
);